import Dashboard from "app/views/Dashboard/Dashboard";
import EmployeeDetails from "app/views/Employee/EmployeeDetails";
import { Navigate } from "react-router-dom";

const AppRoutes = [
  {
    path: "*",
    component: <Navigate to="/" />,
  },
  {
    path: "/",
    component: <Dashboard />,
  },
  {
    path: "/employees-details",
    component: <EmployeeDetails />,
  }
];

export default AppRoutes